import {useMemo, useState, useEffect} from 'react';

import CustomTable, {ICustomTableColumn} from '~/components/CustomTable';

import {useCurrentRoutePath} from '~/hooks/useCurrentRoutePath';
import {useCategoriesList, usePricingList} from '../hooks';
import {getDisplayNameForCategoryKey, getPricingListTableColumn} from './utils';

interface IPricingTableComponentProps {
  searchText: string;
}

const PricingTableComponent = ({searchText}: IPricingTableComponentProps) => {
  const currentPath = useCurrentRoutePath();
  const [pagination, setPagination] = useState({current: 0, pageSize: 10}); // 0-indexed
  const [sorter, setSorter] = useState<{
    sort_by: string;
    sort_direction: 'asc' | 'desc';
  }>({
    sort_by: 'id',
    sort_direction: 'asc',
  });

  const {data: categories = []} = useCategoriesList();

  const selectedCategoryName = getDisplayNameForCategoryKey(currentPath);
  const selectedCategoryId = useMemo(() => {
    const matched = categories.find(cat => cat.name === selectedCategoryName);
    return matched?.id ? String(matched.id) : '';
  }, [categories, selectedCategoryName]);

  useEffect(() => {
    setPagination(prev => ({
      ...prev,
      current: 0,
    }));
  }, [selectedCategoryId]);

  const shouldFetch = !!selectedCategoryId;

  const {data, isLoading} = usePricingList({
    categoryId: selectedCategoryId,
    search: searchText,
    sort_by: sorter.sort_by,
    sort_direction: sorter.sort_direction,
    per_page: pagination.pageSize,
    page_no: pagination.current + 1,
    enabled: shouldFetch,
  });

  const handlePageChange = (newPage: number) => {
    setPagination(prev => ({
      ...prev,
      current: newPage,
    }));
  };

  const handleSortChange = (key: string, direction: 'asc' | 'desc') => {
    setSorter({
      sort_by: key,
      sort_direction: direction,
    });

    setPagination(prev => ({
      ...prev,
      current: 0,
    }));
  };

  const pricingEntries = data?.pricingList ?? [];
  console.log('Pricing Entries:', pricingEntries);

  return (
    <div>
      <CustomTable
        columns={
          getPricingListTableColumn(
            currentPath
          ) as unknown as ICustomTableColumn<Record<string, unknown>>[]
        }
        data={pricingEntries as Record<string, unknown>[]}
        pageSize={pagination.pageSize}
        currentPage={pagination.current}
        onPageChange={handlePageChange}
        onSortChange={handleSortChange}
        sortBy={sorter.sort_by}
        sortDirection={sorter.sort_direction}
        totalCount={data?.totalRecords || 0}
        loading={isLoading}
      />
    </div>
  );
};

export default PricingTableComponent;
